import { render, staticRenderFns } from "./tableSetting.vue?vue&type=template&id=478c55b2&scoped=true"
import script from "./tableSetting.vue?vue&type=script&lang=js"
export * from "./tableSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478c55b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/xrUxRsdL/1/acquirer/pingpong-acquirer-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('478c55b2')) {
      api.createRecord('478c55b2', component.options)
    } else {
      api.reload('478c55b2', component.options)
    }
    module.hot.accept("./tableSetting.vue?vue&type=template&id=478c55b2&scoped=true", function () {
      api.rerender('478c55b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tableSetting.vue"
export default component.exports